export default {
  frogs: "青萍商用多功能检测仪",
  frogS: "青萍商用多功能检测仪",
  //
  frogs_step1_h1: "青萍商用多功能检测仪",
  frogs_step1_device_description_1: "高精度传感器",
  frogs_step1_device_description_2: "多种外接探头可选",
  frogs_step1_device_description_3: "远程无线监控",
  frogs_step1_device_description_4: "超限即时通知",

  frogs_step1_table_1_1: " ",
  frogs_step1_table_1_2: "温度",
  frogs_step1_table_1_3: "湿度",

  frogs_step1_table_2_1: "量程",
  frogs_step1_table_2_2: "-30 ~ 60°C",
  frogs_step1_table_2_3: "0 ~ 100%RH",

  frogs_step1_table_3_1: "典型准确度",
  frogs_step1_table_3_2: "±0.5°C {br}(0 ~ 50°C)",
  frogs_step1_table_3_3: "±5%RH {br}(10 ~ 90%RH)",

  frogs_step1_table_4_1: "分辨力",
  frogs_step1_table_4_2: "0.1°C",
  frogs_step1_table_4_3: "1%RH ",

  frogs_step1_look_specification: "查看完整规格",

  // 222
  frogs_step2_h1: "提供精准检测与可靠连接",

  frogs_step2_1_1: "内置高精度温湿度传感器",
  frogs_step2_1_2: "内置瑞士 Sensirion 温湿度传感器，精度高，反应灵敏。",

  frogs_step2_2_1: "支持外接探头",
  frogs_step2_2_2: "采用航空插头连接方式，稳固可靠。",

  //333
  frogs_step3_h1_1: "整机 IP56{sup} 级防护",
  // frogs_step3_h1_2: " ",

  //444
  frogs_step4_h1: "多种外接探头可选",
  frogs_step4_h2: "查看规格",
  frogs_step4_l_title: "温度探头",
  frogs_step4_r_title: "高浓度二氧化碳探头（扁线）",

  // 6666
  frogs_step6_h1: "两种供电方式",

  frogs_step6_1_1: "方式一：5号电池供电",
  frogs_step6_1_2: "支持锂铁电池、碱性电池（1.5V）。不支持碳性电池、镍氢电池（1.2V）。",

  frogs_step6_2_1: "方式二：USB-C 接口供电",
  frogs_step6_2_2: "可长期连接 USB-C 电源。不支持充电。",

  // 8888
  frogs_step8_h1: "长距离无线通信方案，三选一",
  frogs_step8_info_1: "使用环境需要有稳定 Wi-Fi 信号。",
  frogs_step8_info_2: "需配备 LoRaWAN 网关或基站。",
  frogs_step8_info_3: "需当地中国移动提供相关网络服务",
  frogs_step8_info_3_2: "。",

  //999
  frogs_step9_h1_1: "外置天线，信号更佳",
  frogs_step9_h1_2: "采用 SMA 接口，可轻松安装和维护。",

  //10 10
  frogs_step10_h1_1: "青萍物联",
  frogs_step10_h1_2:
    "为青萍商用智能硬件产品提供设备和数据管理、实时警报服务的物联网平台。",

  //11 11 11
  frogs_step11_h1_1: "意外断网，数据不丢失",
  frogs_step11_h1_2: "设备自身可存储 2,880 组",
  frogs_step11_h1_3:
    "数据，意外断网也无需担心数据丢失，网络恢复后可自动同步数据到云端。",

  //13 13 13 13
  frogs_step13_h1_1: "两种安装方式",
  frogs_step13_h1_2: "DIN 导轨固定",
  frogs_step13_h1_3: "磁吸",

  frogs_bottom_1:
    "经实验室测试，在 GB/T 4208-2017 标准下，青萍商用多功能检测仪的防护水平达到 IP56 级别（用喷头内径为 12.5 毫米的喷嘴，从 2.5～3 米距离处以 100 升/分钟的供水强度向产品持续喷洒 3 分钟，之后产品外观和功能依然正常）。本品不可浸泡于水中或长期处在扬尘环境中。本品的防水、防尘功能并非永久有效，防护性能可能因日常使用而下降。",
  frogs_bottom_2: "外接探头需单独购买。",
  frogs_bottom_3:
    "设备出厂内置 SIM 卡，含 6 年中国移动 NB-IoT 流量资费（限 50MB/年）。不同批次所包含的资费可能不同。",
  frogs_bottom_4: "按 15 分钟记录一组数据计算，设备可在本地存储 30 天的数据。",
  frogs_bottom_5:
    "本品可被安装在 35 毫米 DIN 导轨上，DIN 导轨及固定夹需另行购买。",

  // pop-up co2
  frogs_pop_co2_h1: "高浓度二氧化碳探头（扁线）",
  frogs_pop_co2_h2: "采用多重结构设计，具有良好的防护性和耐用性。",
  frogs_pop_co2_tab_1_1: "不锈钢内衬",
  frogs_pop_co2_tab_1_2: "采用网状设计，保持良好通风的同时，可防止异物进入。",
  frogs_pop_co2_tab_2_1: "高精度传感器",
  frogs_pop_co2_tab_2_2:
    "内置瑞士 Sensirion 二氧化碳传感器，体积小巧，性能出色，稳定性高。",
  frogs_pop_co2_tab_3_1: "铝合金和硅胶外壳",
  frogs_pop_co2_tab_3_2:
    "具有良好的抗氧化性，适用于高温、低温和高湿度等环境。铝合金优异的导热性可加速热量传导，提高传感器响应速度。",
  frogs_pop_co2_item_1: "二氧化碳量程",
  frogs_pop_co2_item_2: "典型准确度",
  frogs_pop_co2_item_3: "工作环境温度",
  frogs_pop_co2_item_4: "工作环境湿度",
  frogs_pop_co2_item_1_2: "0 ~ 25%",
  frogs_pop_co2_item_2_2: "±(1 vol% + 3% m.v.)",
  frogs_pop_co2_item_3_2: "-20 ~ 85°C",
  frogs_pop_co2_item_4_2: "0 ~ 95%RH（无凝露环境）",

  // pop-up temo
  frogs_pop_temp_h1: "温度探头",
  frogs_pop_temp_h2: "可持续放入水中，或无线信号被隔绝的空间，例如冰箱。",
  frogs_pop_temp_item_1: "温度量程",
  frogs_pop_temp_item_2: "典型准确度",
  frogs_pop_temp_item_3: "分辨力",
  frogs_pop_temp_item_4: "材质",
  frogs_pop_temp_item_5: "防护等级",
  frogs_pop_temp_item_1_2: "-40 ~ 125°C",
  frogs_pop_temp_item_2_2: "±0.5°C (0 ~ 50°C)",
  frogs_pop_temp_item_3_2: "0.1°C",
  frogs_pop_temp_item_4_2: "不锈钢探头，硅胶线身。",
  frogs_pop_temp_item_5_2: "IP68*级防护：可防尘，能持续浸水使用。",
  frogs_pop_temp_footer_text:
    "青萍温度探头可防尘，能持续浸水使用。经实验室测试，在 GB/T 4208-2017 标准下，其防护水平达到 IP68 级别（将产品持续浸泡于 1 米深的水中，1 小时后产品外观和功能依然正常）。该产品的防水、防尘功能并非永久有效，防护性能可能因日常使用而下降。",

  //frogs规格-temp
  frogs_spec_long: "80 毫米",
  frogs_spec_short: "33 毫米",
  frogs_spec_height: "208 毫米",
  frogs_size: "产品尺寸",
  frogs_color: "产品颜色",
  frogs_spec_size: "208 × 80 × 33 毫米（含天线）",
  frogs_temp: "温度量程",
  frogs_hum: "湿度量程",
  frogs_temperature:
    "-30 ~ 60°C（使用锂铁 5 号电池或 USB 供电）{br}{br}-10 ~ 50°C（使用碱性 5 号电池）",
    frogs_temperature_pc:
    "-30 ~ 60°C（使用锂铁 5 号电池或 USB 供电）{br}-10 ~ 50°C（使用碱性 5 号电池）",
  frogs_humidity: "0 ~ 100%RH",

  frogs_weight: "128 克",
  frogs_screen_size: "64 × 44 毫米",
  frogs_wifi: "Wi-Fi 2.4GHz 或 NB-IoT 或 LoRa",
  frogs_ble: "5.0",
  frogs_battery_support: "电池供电",
  frogs_battery_support_v: "2 节 5 号锂铁电池或碱性电池",
  frogs_USB_support: "USB 供电",
  frogs_package_USB: "5V⎓1A，USB-C",
  frogs_protect: "IP56",
  frogs_package_name: "青萍商用多功能{br}检测仪",
  frogs_package_battery: "2 节 5 号{br}锂铁电池",

  under_ninty2: "请勿长时间在湿度超过 90%RH 的环境下使用。",
  under_ninty3:
    "当已连接 USB 时，设备将只使用 USB 电源工作（不使用电池），设备的 USB 口不支持为电池充电。",

  frogs_device_modal: "产品型号",
  frogs_device_modal_v: "CGF2P-T40",
  frogs_needle_size:
    "传感器探头：直径 6 毫米，长度 50 毫米{br}线身：直径 5 毫米，长度 1500 毫米{br}连接器：长度 35 毫米",
    frogs_needle_size_m:
    "传感器探头：直径 6 毫米，长度 50 毫米{br}{br}线身：直径 5 毫米，长度 1500 毫米{br}{br}连接器：长度 35 毫米",

  frogs_first_level: "防护等级{br}",
  frogs_needle_weight: "57 克",
  frogs_needle_connect: "M8 六孔航空插头",
  frogs_needle_protect: "IP68",

  frogs_needle_material: "不锈钢",
  frogs_needle_body: "硅胶",
  frogs_needle_line: "连接器",
  frogs_needle_with: "PET",
  frogs_needle_package_with: "胶带{br}(用于固定产品)",

  //frogs规格-temp

  frogs_needle_co2_tab: "高浓度二氧化碳探头（扁线）",
  frogs_needle_co2_size:
    "传感器探头：直径 21 毫米，长度 51 毫米 {br}线身：1.5 × 4 毫米，长度 1500 毫米 {br}连接器：长度 35 毫米",
    frogs_needle_co2_size_m:
    "传感器探头：直径 21 毫米，长度 51 毫米 {br}{br}线身：1.5 × 4 毫米，长度 1500 毫米 {br}{br}连接器：长度 35 毫米",

  p_co2: "二氧化碳{br}量程",
  needle_co2_temperature: "0 ~ 25%",
  frogs_needle_co2: "青萍高浓度二氧化碳探头（扁线）",
  frogs_probe_co2_modal_v: "CGF2P-HC-F",
  frogs_needle_co2_weight: "14 克",
  frogs_needle_co2_connect: "M8 六孔航空插头",
  frogs_first_level_co2: "线身和连接器重量",
  frogs_needle_co2_protect: "21 克",

  frogs_needle_co2_material: "铝合金、硅胶、不锈钢",
  frogs_needle_co2_body: "硅胶",
  frogs_needle_co2_line: "连接器",
  frogs_needle_co2_line_v: "不锈钢",
  frogs_needle_co2_with: "PET",
  frogs_needle_co2_package_with: "胶带{br}(用于固定产品)",

  workEnvironment: "工作环境",
  work_co2_tem: "温度",
  work_co2_hum: "湿度",
  work_co2_tem_v: " -20 ~ 85°C",
  work_co2_hum_v: "0 ~ 95%RH（无凝露环境）",

  x_co2_bottom: "1500 毫米",
  x_co2_left: "35 毫米",
  x_co2_right: "51 毫米",
  x_co2_right_2: "40 毫米",

  x_bottom: "1500 毫米",
  x_left: "35 毫米",
  x_right: "50 毫米",

  //
  p_probe_type: "外接探头",
  p_probe_tem: "温度探头",
  "p_probe_tem&hum": "湿度探头",
  "p_probe_c02&tem&hum": "外接 CO2 + 温湿度",
  p_probe_co2: "CO2 探头",
  p_probe_none: "无",

  //fix
  frogs_needles: "温度探头",
  frogs_needle: "青萍温度探头",

  frogs_p_weight: "探头重量",
  frogs_sensor_body: "传感器线身",

  mp_multi_scene: "多场景专业应用",    
  
  frogs_support_1: "温湿度监测",
  frogs_support_2: "多种外接探头可选",
};
